import React from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, Team } from "..";

export const TeamZeta = () => {
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const aboutDetails = useStore((state) => state.aboutDetails);

  const overlay = {
    where: "aboutZeta",
    title: "Meet Zeta",
    caption: "Justine and Zeta practice 'Watch Me'.",
  };
  const info = {
    routes: {
      Home: "/",
      "Todo's Team": getLink(pathTitles.MEETTHETEAM),
      "Meet Zeta": getLink(pathTitles.MEETZETA),
    },
    body: aboutDetails.ZETA.body,
  };
  return (
    <>
      <SEO
        title="Meet Zeta — Todo's Translator Demo Dog"
        description="Meet Zeta, one of Todo's Translator's demonstration dogs. Discover her story and how she helps Justine teach obedience and focus."
        path="/meet-the-trainer/zeta"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <Team info={info} />
        </>
      )}
    </>
  );
};
